import {IconLightBulb} from "~/assets";
import {Container, Text} from "~/new-design/components";
import {colors, spacing} from "~/new-design/theme";

type EducationalFlowLinkProps = {
  onClick: () => void;
};

export const EducationalFlowLink = ({onClick}: EducationalFlowLinkProps) => (
  <Container row center gap={2} onClick={onClick} sx={{py: spacing[2.5]}}>
    <IconLightBulb color={colors.primary[600]} width={16} height={16} />
    <Text variant="body-semibold" color={colors.primary[600]} sx={{textDecoration: "underline"}}>
      Understand how debt works first
    </Text>
  </Container>
);
